var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.1665 1.33301H4.49984C4.14622 1.33301 3.80708 1.47348 3.55703 1.72353C3.30698 1.97358 3.1665 2.31272 3.1665 2.66634V13.333C3.1665 13.6866 3.30698 14.0258 3.55703 14.2758C3.80708 14.5259 4.14622 14.6663 4.49984 14.6663H12.4998C12.8535 14.6663 13.1926 14.5259 13.4426 14.2758C13.6927 14.0258 13.8332 13.6866 13.8332 13.333V5.99967M9.1665 1.33301L13.8332 5.99967M9.1665 1.33301V5.99967H13.8332",
    stroke: "#20B3D5",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.2d5fc94e4e2398a163cff9c2ddde8c2b.svg";
export { ForwardRef as ReactComponent };